"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[593],{

/***/ 12671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ Badge; }
});

// UNUSED EXPORTS: VARIANT_OPTIONS

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
;// CONCATENATED MODULE: ./helpers/utils/date.ts

var isValidDate = function(date) {
    return !isNaN(date.getTime());
};
var formatDate = function(datetime, format, locale) {
    var date = new Date(datetime);
    if (!isValidDate(date)) return datetime;
    return date.toLocaleDateString(locale || "en-US", format || {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
var formatDates = function(dates, locale) {
    var showTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // console.log('locale', locale);
    var extraDateOptions = showTime ? {
        hour: "2-digit",
        minute: "2-digit"
    } : {};
    if (Array.isArray(dates)) {
        var startDate = dates[0];
        var endDate = dates[1];
        // both start and end date
        if (startDate && endDate) {
            return "".concat(formatDate(startDate, (0,_object_spread/* default */.Z)({
                day: "numeric",
                month: "short"
            }, extraDateOptions), locale), " - ").concat(formatDate(endDate, (0,_object_spread/* default */.Z)({
                day: "numeric",
                month: "short",
                year: "numeric"
            }, extraDateOptions), locale));
        }
        // only start date
        if (startDate && !endDate) {
            return formatDate(startDate, (0,_object_spread/* default */.Z)({
                day: "numeric",
                month: "short",
                year: "numeric"
            }, extraDateOptions), locale);
        }
        // only end date
        if (!startDate && endDate) {
            return formatDate(endDate, (0,_object_spread/* default */.Z)({
                day: "numeric",
                month: "short",
                year: "numeric"
            }, extraDateOptions), locale);
        }
    // basic string
    } else {
        var isDate = false;
        // 2022-11-05 is a valid format
        if (/\d{4}-\d{2}-\d{2}/.test(dates)) isDate = true;
        // 1 Nov 2022 is a valid format
        if (/\d{1,2}\s\w+\s\d{4}/.test(dates)) isDate = true;
        if (!isDate) return dates;
        // basic date
        return formatDate(dates, (0,_object_spread/* default */.Z)({
            day: "numeric",
            month: "short",
            year: "numeric"
        }, extraDateOptions), // 'en-Gb',
        locale);
    }
};
// get the date format
var getLocale = function(language) {
    var locale;
    if (language === "en") {
        locale = "en-GB";
    } else if (language === "es") {
        locale = "es-ES";
    } else if (language === "it") {
        locale = "it-IT";
    }
    return locale;
};

;// CONCATENATED MODULE: ./components/Badge/Badge.tsx






var VARIANT_OPTIONS = {
    brand: "Brand",
    action: "Action",
    success: "Success",
    alert: "Alert",
    neutral: "Neutral",
    ghost: "Ghost",
    white: "white",
    "neutral-gradient": "Neutral gradient",
    "brand-gradient": "Brand gradient"
};
var variantClasses = {
    brand: "pyxis-badge-brand",
    action: "pyxis-badge-action",
    success: "pyxis-badge-success",
    alert: "pyxis-badge-alert",
    neutral: "pyxis-badge-neutral",
    ghost: "pyxis-badge-ghost",
    white: "pyxis-badge-white",
    "neutral-gradient": "pyxis-badge-neutral-gradient",
    "brand-gradient": "pyxis-badge-brand-gradient"
};
var Badge = function(param) {
    var variant = param.variant, label = param.label, labelIsDate = param.labelIsDate, alt = param.alt, className = param.className, locale = param.locale;
    var router = (0,next_router.useRouter)();
    if (!locale) locale = router === null || router === void 0 ? void 0 : router.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()("pyxis-badge", variantClasses[variant], (0,_define_property/* default */.Z)({}, "pyxis-badge-alt", alt), className),
        children: labelIsDate === true ? formatDates(label, getLocale(locale)) : label
    });
};


/***/ }),

/***/ 41183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Jobs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43470);
/* harmony import */ var _Badge_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12671);
/* harmony import */ var _buttons_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76609);
/* harmony import */ var _images_IconLoader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64162);







var Jobs = function(param) {
    var items = param.items;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_3__/* .PageContext */ .z), sitemap = ref2.sitemap, locale = ref2.locale, config = ref2.config;
    var translations = config.translations;
    var jobOverviewPagePath = (ref = sitemap.find(function(param) {
        var _id = param._id;
        return _id === "page_jobs";
    })) === null || ref === void 0 ? void 0 : (ref1 = ref.paths) === null || ref1 === void 0 ? void 0 : ref1[locale];
    if (!Boolean(items === null || items === void 0 ? void 0 : items.filter(Boolean).length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "flex flex-col gap-3 md:gap-0",
        children: items.map(function(param, index) {
            var title = param.title, shortcode = param.shortcode, slug = param.slug, location = param.location, department = param.department, created_at = param.created_at;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative rounded-xl px-4 md:px-8 py-4 md:py-6 group", "transition-all hover:shadow-lg focus-within:shadow-lg duration-500", "shadow-lg md:shadow-none", "bg-white md:bg-transparent", "hover:bg-white focus-within:bg-white hover:z-10", "flex flex-col md:flex-row gap-2 md:gap-8 md:items-center", "md:-mt-0.5"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "sm:w-3/5 md:w-1/2 flex flex-col-reverse md:flex-col gap-1 md:gap-3 pr-10 md:pr-16",
                        children: [
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_buttons_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, {
                                href: "".concat(jobOverviewPagePath, "/").concat(slug),
                                className: "outline-none",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "absolute inset-0 bg-neutral-25 block opacity-0 z-10 cursor-pointer"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("font-bold text-neutral-base text-title-sm-sm md:text-title-md-md lg:text-title-md-lg", "group-hover:underline group-focus-within:underline underline-offset-4 md:group-hover:no-underline md:group-focus-within:no-underline"),
                                        children: [
                                            title,
                                            isNew(created_at) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "align-middle absolute right-4 top-0 md:relative md:right-auto md:top-auto md:ml-4 inline-flex",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "absolute inset-x-0 h-4 bg-brand-light md:hidden"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "w-4 bg-white h-6 rounded-tr-sm relative z-10 md:hidden"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Badge_Badge__WEBPACK_IMPORTED_MODULE_4__/* .Badge */ .C, {
                                                        variant: "white",
                                                        label: "new",
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative z-10", "bg-brand-light text-brand-dark", "md:bg-white md:text-brand-base", "group-hover:bg-brand-light group-hover:text-brand-dark")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "w-4 bg-white h-6 rounded-tl-sm relative z-10 md:hidden"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            department && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold text-brand-base text-sm md:text-title-sm-md lg:text-title-sm-lg",
                                children: department
                            })
                        ]
                    }),
                    location && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex gap-2 text-neutral-25 font-bold text-md items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_6__/* .IconLoader */ .p, {
                                icon: "map-marker",
                                className: "w-6 h-6"
                            }),
                            " ",
                            formatLocationLabel({
                                city: location === null || location === void 0 ? void 0 : location.city,
                                country: location === null || location === void 0 ? void 0 : location.country,
                                telecommuting: location === null || location === void 0 ? void 0 : location.telecommuting,
                                translations: translations,
                                locale: locale
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-10 h-10 md:border-2 md:border-action-base text-action-base rounded-full flex items-center justify-center absolute right-4 md:right-8 top-1/2 -translate-y-1/2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_6__/* .IconLoader */ .p, {
                            icon: "chevron",
                            className: "w-5 h-5 -rotate-90"
                        })
                    }),
                    index !== (items === null || items === void 0 ? void 0 : items.length) - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hidden md:block h-0.5 bg-neutral-85 absolute left-0 right-0 bottom-0 group-hover:opacity-0 transition-opacity duration-500"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hidden md:block h-0.5 bg-neutral-95 absolute left-0 right-0 top-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    })
                ]
            }, shortcode || title);
        })
    });
};
function isNew(date) {
    return new Date(date) > new Date(Date.now() - 1000 * 60 * 60 * 24 * 7);
}
function formatLocationLabel(param) {
    var city = param.city, country = param.country, telecommuting = param.telecommuting, translations = param.translations, locale = param.locale;
    var ref;
    var label = [
        city,
        country
    ].filter(Boolean).join(", ");
    if ((label === null || label === void 0 ? void 0 : label.length) && telecommuting) label += " / ";
    if (telecommuting) label += (translations === null || translations === void 0 ? void 0 : (ref = translations.full_remote) === null || ref === void 0 ? void 0 : ref[locale]) || "remote";
    return label;
}


/***/ }),

/***/ 90231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export ButtonMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49853);
/* harmony import */ var _images_IconLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64162);
/* harmony import */ var _loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58998);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76609);










var variantClasses = {
    primary: "pyxis-btn-primary",
    secondary: "pyxis-btn-secondary",
    tertiary: "pyxis-btn-tertiary",
    brand: "pyxis-btn-brand",
    ghost: "pyxis-btn-ghost",
    white: "pyxis-btn-white"
};
var sizeClasses = {
    sm: "pyxis-btn-small",
    md: "pyxis-btn-medium",
    lg: "pyxis-btn-large",
    xl: "pyxis-btn-huge"
};
var iconSizeClasses = {
    sm: "w-4 h-4",
    md: "w-4 h-4",
    lg: "w-4 h-4",
    xl: "w-4 h-4"
};
var iconOnlySizeClasses = {
    sm: "w-10 h-10 md:w-10 md:h-10",
    md: "w-10 h-10 md:w-11 md:h-11",
    lg: "w-10 h-10 md:w-11 md:h-11",
    xl: "w-10 h-10 md:w-11 md:h-11"
};
var Button = function(props) {
    if ((0,_helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__/* .isInternalLink */ .F)(props.href)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, {
            href: props.href,
            locale: props.language,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                as: "span"
            }))
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props));
};
var ButtonMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Button)));
var ButtonInner = function(param) {
    var _as = param.as, as = _as === void 0 ? "a" : _as, _label = param.label, label = _label === void 0 ? "" : _label, href = param.href, onClick = param.onClick, target = param.target, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = param.size, size = _size === void 0 ? "lg" : _size, icon = param.icon, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "after" : _iconPosition, _compact = param.compact, compact = _compact === void 0 ? false : _compact, ariaLabel = param.ariaLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _download = param.download, download = _download === void 0 ? false : _download, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, _stretch = param.stretch, stretch = _stretch === void 0 ? false : _stretch, _alt = param.alt, alt = _alt === void 0 ? false : _alt;
    var Element = as === "submit" ? "button" : as;
    var props = {
        type: null,
        href: null,
        target: null,
        download: null,
        title: null,
        disabled: null
    };
    if (target === "_blank") {
        icon = "external-link";
        iconPosition = "after";
    }
    if (hideLabel) {
        ariaLabel = props.title = label;
        label = "";
    }
    label = label || "";
    iconPosition = iconPosition || "after";
    // prevent orphan icon by adding first / last word to icon
    var labelWords = label === null || label === void 0 ? void 0 : label.split(" ");
    if (as === "button") {
        props.type = "button";
    }
    if (as === "submit") {
        props.type = "button";
    }
    if (as === "a") {
        props.href = href;
        props.target = target;
    }
    if (download) {
        var ref;
        props.download = true;
        if (((ref = props.href) === null || ref === void 0 ? void 0 : ref.indexOf(".sanity.io")) > -1) props.href = "".concat(props.href, "?dl");
    }
    if (disabled) {
        props.disabled = "disabled";
    }
    var handleClick = function(e) {
        return disabled ? function() {} : onClick ? onClick(e) : function() {};
    };
    var ButtonIcon = icon ? function(param) {
        var wordBefore = param.wordBefore, wordAfter = param.wordAfter;
        var _obj;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "whitespace-nowrap break-all",
            children: [
                wordBefore && " ".concat(wordBefore),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline text-current", iconSizeClasses[size], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "mr-2", wordAfter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "ml-2", wordBefore), _obj)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_3__/* .IconLoader */ .p, {
                        icon: icon,
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-block translate-y-1", iconSizeClasses[size])
                    })
                }),
                wordAfter && "".concat(wordAfter, " ")
            ]
        });
    } : null;
    var _obj;
    var sharedClasses = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, sizeClasses[size], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, variantClasses[variant], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn-alt", alt), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "inline-flex items-center justify-center", !stretch), _obj);
    // icon only button
    if (!(label === null || label === void 0 ? void 0 : label.trim().length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            "aria-label": ariaLabel || label,
            onClick: handleClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconOnlySizeClasses[size], !compact)),
                children: [
                    ButtonIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {}),
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                ]
            })
        }));
    }
    // icon + text button
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        "aria-label": ariaLabel || label,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, sizeClasses[size], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, "w-full flex", stretch)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-left break-words",
                children: ButtonIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        ButtonIcon && iconPosition === "before" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordAfter: labelWords[0]
                        }),
                        iconPosition === "before" ? labelWords.slice(1).join(" ") : labelWords.slice(0, -1).join(" "),
                        ButtonIcon && iconPosition === "after" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordBefore: labelWords[labelWords.length - 1]
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "flex",
                    children: [
                        label,
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                })
            })
        })
    }));
};
var ButtonLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "h-5 w-5 inline-flex self-center align-middle ml-2 -mb-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__/* .Spinner */ .$, {})
    });
};


/***/ }),

/***/ 86133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JobFinder": function() { return /* binding */ JobFinder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69779);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pyxis_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98647);
/* harmony import */ var _radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(93754);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_Jobs_Jobs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41183);
/* harmony import */ var _components_buttons_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90231);
/* harmony import */ var _components_images_IconLoader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64162);
/* harmony import */ var _components_meta_ScriptJsonLd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18164);
/* harmony import */ var _components_module_Background__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9403);
/* harmony import */ var _components_module_Bleed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13845);
/* harmony import */ var _components_module_Spacing__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65355);
/* harmony import */ var _components_module_Width__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55668);
/* harmony import */ var _components_module_Wrapper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83118);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43470);
/* harmony import */ var _helpers_sitemap_getURLForPath__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26095);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23302);






















var titleClassName = "text-title-3xl-sm md:text-title-3xl-md lg:text-title-3xl-lg font-bold decoration-2 underline-offset-4 focus:outline-none select-none";
var JOBS_PER_PAGE = 10;
var JobFinder = function(param) {
    var jobs = param.jobs, countries = param.countries, departments = param.departments;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_13__/* .PageContext */ .z), config = ref21.config, locale = ref21.locale, sitemap = ref21.sitemap;
    var translations = config.translations;
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), filterCountry = ref22[0], setFilterCountry = ref22[1];
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), filterOffice = ref23[0], setFilterOffice = ref23[1];
    var ref24 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), filterDepartment = ref24[0], setFilterDepartment = ref24[1];
    var ref25 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), filterRemote = ref25[0], setFilterRemote = ref25[1];
    var ref26 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(1), currentPage = ref26[0], setCurrentPage = ref26[1];
    var filteredJobs = jobs.filter(function(job) {
        var ref, ref1, ref2;
        var isRemote = (ref = job.location) === null || ref === void 0 ? void 0 : ref.telecommuting;
        var countryCode = (ref1 = job.location) === null || ref1 === void 0 ? void 0 : ref1.country_code;
        var city = (ref2 = job.location) === null || ref2 === void 0 ? void 0 : ref2.city;
        var department = job.department;
        // if (isRemote === true && filterRemote === false) return false;
        if (isRemote === false && filterRemote === true) return false;
        // country
        if (filterCountry && filterCountry !== _types__WEBPACK_IMPORTED_MODULE_15__/* .OTHER_COUNTRY_CODE */ .KW && countryCode !== filterCountry) return false;
        // international, other countries not in list
        if (filterCountry && filterCountry === _types__WEBPACK_IMPORTED_MODULE_15__/* .OTHER_COUNTRY_CODE */ .KW && countries.find(function(param) {
            var code = param.code;
            return code === countryCode;
        })) return false;
        // office
        if (filterOffice && city !== filterOffice) return false;
        // department
        if (filterDepartment && department !== filterDepartment) return false;
        return true;
    });
    var hasNext = filteredJobs.length > currentPage * JOBS_PER_PAGE;
    var officesDict = (ref = jobs === null || jobs === void 0 ? void 0 : jobs.filter(function(param) {
        var location = param.location;
        return Boolean(location === null || location === void 0 ? void 0 : location.city);
    })) === null || ref === void 0 ? void 0 : ref.reduce(function(prev, curr) {
        var ref, ref1, ref2, ref3, ref4;
        if (!((ref = curr.location) === null || ref === void 0 ? void 0 : ref.city)) return prev;
        if (((ref1 = curr.location) === null || ref1 === void 0 ? void 0 : ref1.country_code) !== filterCountry) return prev;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, (ref2 = curr.location) === null || ref2 === void 0 ? void 0 : ref2.city, {
            city: (ref3 = curr.location) === null || ref3 === void 0 ? void 0 : ref3.city,
            country: (ref4 = curr.location) === null || ref4 === void 0 ? void 0 : ref4.country
        }));
    }, {});
    var offices = Object.values(officesDict);
    var jobOverviewPagePath = (ref1 = sitemap.find(function(param) {
        var _id = param._id;
        return _id === "page_jobs";
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.paths) === null || ref2 === void 0 ? void 0 : ref2[locale];
    var jobsJsonLd = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: jobs === null || jobs === void 0 ? void 0 : jobs.map(function(job, i) {
            var ref;
            return {
                "@type": "ListItem",
                position: i + 1,
                name: job.title,
                url: (0,_helpers_sitemap_getURLForPath__WEBPACK_IMPORTED_MODULE_14__/* .getURLForPath */ .i)(config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.domain, "".concat(jobOverviewPagePath, "/").concat(job.slug), locale)
            };
        }).filter(Boolean)
    };
    var clearFilters = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        setFilterCountry(null);
        setFilterOffice("");
        setFilterDepartment("");
        setFilterRemote(false);
        setCurrentPage(1);
    }, []);
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "-mt-12 sm:-mt-16 md:tablet:-mt-12 tablet:-mt-16 lg:-mt-12 xl:-mt-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Bleed__WEBPACK_IMPORTED_MODULE_9__/* .Bleed */ .zu, {
                bleed: "sm",
                className: "relative z-20 pointer-events-none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Spacing__WEBPACK_IMPORTED_MODULE_10__/* .Spacing */ .K, {
                    space: {
                        top: "none",
                        bottom: "none"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Width__WEBPACK_IMPORTED_MODULE_11__/* .Width */ .L, {
                        width: "outer",
                        className: "pt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Background__WEBPACK_IMPORTED_MODULE_8__/* .Background */ .Aq, {
                            theme: {
                                background: "neutral-95",
                                rounded: {
                                    top: "lg"
                                }
                            },
                            className: "border border-transparent",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Width__WEBPACK_IMPORTED_MODULE_11__/* .Width */ .L, {
                                width: "inner",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col gap-4 md:gap-8 border-2 border-neutral-85 bg-white p-6 md:p-10 xl:p-14 -translate-y-1/2 rounded-2xl -mb-24 shadow-lg max-w-[900px] mx-10 2xl:mx-0 pointer-events-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "grid lg:grid-cols-12 flex-wrap gap-4 leading-none relative",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "lg:col-span-9",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-title-3xl-sm md:text-title-3xl-md lg:text-title-3xl-lg font-bold text-neutral-base whitespace-nowrap",
                                                                children: translations === null || translations === void 0 ? void 0 : (ref3 = translations.positions_in) === null || ref3 === void 0 ? void 0 : ref3[locale]
                                                            }),
                                                            "\xa0\xa0\xa0",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Root */ .fC, {
                                                                value: filterCountry,
                                                                onValueChange: setFilterCountry,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Trigger */ .xz, {
                                                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("underline text-brand-base hover:text-brand-dark focus:text-brand-dark", titleClassName),
                                                                        asChild: true,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Value */ .B4, {}),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Icon */ .JO, {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_images_IconLoader__WEBPACK_IMPORTED_MODULE_6__/* .IconLoader */ .p, {
                                                                                        icon: "chevron",
                                                                                        className: "inline-block w-6 h-6 md:w-9 md:h-9 lg:w-11 lg:h-11 text-brand-base align-middle"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Portal */ .h_, {
                                                                        className: "z-60",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Content */ .VY, {
                                                                            className: "ml-auto",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .ScrollUpButton */ .u_, {}),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Viewport */ .l_, {
                                                                                    className: "relative bg-white text-lg rounded-md shadow-lg",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            className: "block absolute inset-0 border-2 border-neutral-85 rounded-md pointer-events-none"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Item */ .ck, {
                                                                                            value: null,
                                                                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-4 hover:underline focus:underline focus:bg-neutral-95 hover:bg-neutral-95", titleClassName, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "text-brand-base", !filterCountry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "text-neutral-base", filterCountry), _obj)),
                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .ItemText */ .eT, {
                                                                                                children: translations === null || translations === void 0 ? void 0 : (ref4 = translations.all_countries) === null || ref4 === void 0 ? void 0 : ref4[locale]
                                                                                            })
                                                                                        }),
                                                                                        countries === null || countries === void 0 ? void 0 : countries.map(function(param) {
                                                                                            var name = param.name, code = param.code;
                                                                                            var _obj;
                                                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .Item */ .ck, {
                                                                                                value: code,
                                                                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("py-4 pl-4 pr-10 hover:underline focus:underline focus:bg-neutral-95 hover:bg-neutral-95", titleClassName, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "text-brand-base", code === filterCountry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_obj, "text-neutral-base", code !== filterCountry), _obj)),
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .ItemText */ .eT, {
                                                                                                    children: name
                                                                                                })
                                                                                            }, code);
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_select__WEBPACK_IMPORTED_MODULE_19__/* .ScrollDownButton */ .$G, {})
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "flex items-start lg:justify-end gap-4 lg:col-span-3 lg:pt-7",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-neutral-base text-lg mt-1",
                                                            children: translations === null || translations === void 0 ? void 0 : (ref5 = translations.full_remote) === null || ref5 === void 0 ? void 0 : ref5[locale]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                            className: "inline-flex relative items-center cursor-pointer",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: filterRemote,
                                                                    className: "sr-only peer",
                                                                    onChange: function(e) {
                                                                        return setFilterRemote(e.target.checked);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "w-11 h-6 bg-neutral-75 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-action-light rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-action-base"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        Boolean(offices === null || offices === void 0 ? void 0 : offices.length) && Boolean((offices === null || offices === void 0 ? void 0 : offices.length) > 1) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pyxis_react__WEBPACK_IMPORTED_MODULE_1__.Select, {
                                                onChange: function(e) {
                                                    return setFilterOffice(e.target.value);
                                                },
                                                placeholder: filterOffice ? translations === null || translations === void 0 ? void 0 : (ref6 = translations.all_office_locations) === null || ref6 === void 0 ? void 0 : ref6[locale] : translations === null || translations === void 0 ? void 0 : (ref7 = translations.office_location) === null || ref7 === void 0 ? void 0 : ref7[locale],
                                                label: filterOffice ? translations === null || translations === void 0 ? void 0 : (ref8 = translations.all_office_locations) === null || ref8 === void 0 ? void 0 : ref8[locale] : translations === null || translations === void 0 ? void 0 : (ref9 = translations.office_location) === null || ref9 === void 0 ? void 0 : ref9[locale],
                                                items: [
                                                    {
                                                        value: null,
                                                        label: filterOffice ? translations === null || translations === void 0 ? void 0 : (ref10 = translations.all_office_locations) === null || ref10 === void 0 ? void 0 : ref10[locale] : (translations === null || translations === void 0 ? void 0 : (ref11 = translations.office_location) === null || ref11 === void 0 ? void 0 : ref11[locale]) || "…"
                                                    }, 
                                                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(offices.map(function(param) {
                                                    var city = param.city;
                                                    return {
                                                        value: city,
                                                        label: city
                                                    };
                                                }))),
                                                name: "office",
                                                value: filterOffice,
                                                size: "m",
                                                className: "[&_input]:rounded-[0.5em]",
                                                isHiddenLabel: true
                                            })
                                        }),
                                        Boolean(departments === null || departments === void 0 ? void 0 : departments.length) && Boolean((departments === null || departments === void 0 ? void 0 : departments.length) > 1) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pyxis_react__WEBPACK_IMPORTED_MODULE_1__.Select, {
                                                onChange: function(e) {
                                                    return setFilterDepartment(e.target.value);
                                                },
                                                placeholder: filterDepartment ? translations === null || translations === void 0 ? void 0 : (ref12 = translations.all_departments) === null || ref12 === void 0 ? void 0 : ref12[locale] : translations === null || translations === void 0 ? void 0 : (ref13 = translations.department) === null || ref13 === void 0 ? void 0 : ref13[locale],
                                                label: filterDepartment ? translations === null || translations === void 0 ? void 0 : (ref14 = translations.all_departments) === null || ref14 === void 0 ? void 0 : ref14[locale] : translations === null || translations === void 0 ? void 0 : (ref15 = translations.department) === null || ref15 === void 0 ? void 0 : ref15[locale],
                                                items: [
                                                    {
                                                        value: null,
                                                        label: filterDepartment ? translations === null || translations === void 0 ? void 0 : (ref16 = translations.all_departments) === null || ref16 === void 0 ? void 0 : ref16[locale] : (translations === null || translations === void 0 ? void 0 : (ref17 = translations.department) === null || ref17 === void 0 ? void 0 : ref17[locale]) || "…"
                                                    }, 
                                                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(departments.map(function(param) {
                                                    var name = param.name, code = param.code;
                                                    return {
                                                        value: name,
                                                        label: name
                                                    };
                                                }))),
                                                name: "department",
                                                value: filterDepartment,
                                                size: "m",
                                                className: "relative [&_.form-dropdown-wrapper]:z-60",
                                                isHiddenLabel: true
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_module_Wrapper__WEBPACK_IMPORTED_MODULE_12__/* .Wrapper */ .i, {
                theme: {
                    space: {
                        top: "none",
                        bottom: "xl"
                    },
                    background: "neutral-95",
                    rounded: {
                        top: "none"
                    }
                },
                className: "relative z-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pb-20",
                        children: Boolean(filteredJobs === null || filteredJobs === void 0 ? void 0 : filteredJobs.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Jobs_Jobs__WEBPACK_IMPORTED_MODULE_4__/* .Jobs */ .p, {
                            items: filteredJobs.slice(0, currentPage * JOBS_PER_PAGE)
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "xs:mt-4 md:mt-0 mx-2 relative rounded-xl p-6 0 md:p-8 shadow-lg md:shadow-none bg-white md:bg-transparent mb-11",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "font-bold text-neutral-base text-title-sm-sm md:text-title-md-md lg:text-title-md-lg mb-6",
                                    children: translations === null || translations === void 0 ? void 0 : (ref18 = translations.no_jobs_found) === null || ref18 === void 0 ? void 0 : ref18[locale]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_buttons_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                                        label: translations === null || translations === void 0 ? void 0 : (ref19 = translations.job_finder_clear_filters) === null || ref19 === void 0 ? void 0 : ref19[locale],
                                        onClick: clearFilters
                                    })
                                })
                            ]
                        })
                    }),
                    hasNext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center pb-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_buttons_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                            label: translations === null || translations === void 0 ? void 0 : (ref20 = translations.job_finder_show_more) === null || ref20 === void 0 ? void 0 : ref20[locale],
                            onClick: function() {
                                return setCurrentPage(function(n) {
                                    return n + 1;
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_ScriptJsonLd__WEBPACK_IMPORTED_MODULE_7__/* .ScriptJsonLd */ .a, {
                        data: jobsJsonLd
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.memo(JobFinder));


/***/ })

}]);